import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useAuth } from './context/AuthContext';
import { resolveScraperOrigin, resolveScraperUrl } from './utils/scraperUrl';

const SCRAPER_READY = 'SCRAPER_EMBED_READY';
const AUCTION_SESSION = 'AUCTION_EMBED_SESSION';
const SCRAPER_AUTH_REQUIRED = 'SCRAPER_AUTH_REQUIRED';
const SCRAPER_REQUEST_LOGOUT = 'SCRAPER_REQUEST_LOGOUT';

const ScraperEmbedPage = () => {
  const { token, user, logout } = useAuth();
  const iframeRef = useRef(null);
  const [bridgeReady, setBridgeReady] = useState(false);
  const scraperOrigin = useMemo(
    () => resolveScraperOrigin(process.env.REACT_APP_SCRAPER_ORIGIN),
    []
  );
  const scraperEmbedUrl = useMemo(() => {
    const url = resolveScraperUrl(process.env.REACT_APP_SCRAPER_URL);
    url.pathname = '/embed';
    url.search = '';
    url.hash = '';
    return url.toString();
  }, []);

  const sendSessionToScraper = useCallback(() => {
    if (!token || !user) return false;
    const frameWindow = iframeRef.current?.contentWindow;
    if (!frameWindow) return false;

    frameWindow.postMessage(
      {
        type: AUCTION_SESSION,
        payload: { token, user },
      },
      scraperOrigin
    );
    return true;
  }, [scraperOrigin, token, user]);

  useEffect(() => {
    const onMessage = (event) => {
      const frameWindow = iframeRef.current?.contentWindow;
      if (!frameWindow || event.source !== frameWindow) return;
      if (event.origin !== scraperOrigin) return;
      const eventType = event?.data?.type;
      if (eventType === SCRAPER_READY) {
        setBridgeReady(true);
        sendSessionToScraper();
        return;
      }
      if (eventType === SCRAPER_AUTH_REQUIRED) {
        logout();
        return;
      }
      if (eventType === SCRAPER_REQUEST_LOGOUT) {
        logout();
      }
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [logout, scraperOrigin, sendSessionToScraper]);

  useEffect(() => {
    if (!bridgeReady) return;
    sendSessionToScraper();
  }, [bridgeReady, sendSessionToScraper]);

  return (
    <div className="h-[calc(100vh-140px)] min-h-[720px]">
      <iframe
        ref={iframeRef}
        title="Auction Scraper"
        src={scraperEmbedUrl}
        className="w-full h-full rounded-lg border border-hairline bg-surface"
      />
    </div>
  );
};

export default ScraperEmbedPage;
